export const ALL_BODY_STYLE_LABEL = 'All types';

export type BodyStyleKey = 'hatch' | 'sedans' | 'suvs' | 'sport' | 'peopleMovers' | 'commercial';

export const BODY_STYLE_KEYS: BodyStyleKey[] = ['hatch', 'sedans', 'suvs', 'sport', 'peopleMovers', 'commercial'];

export const BODY_STYLE_OPTIONS: Record<BodyStyleKey, { label: string; imageUrl: string }> = {
  hatch: { label: 'Hatch & Small Cars', imageUrl: '/images/hatch.jpg' },
  sedans: { label: 'Sedans & wagons', imageUrl: '/images/sedans.jpg' },
  suvs: { label: 'SUVs & 4WDs', imageUrl: '/images/suvs.jpg' },
  sport: { label: 'Sport', imageUrl: '/images/sport.jpg' },
  peopleMovers: { label: 'People movers', imageUrl: '/images/people-movers.jpg' },
  commercial: { label: 'Utes & vans', imageUrl: '/images/commercial.jpg' },
};
